export default {
	path: '/object-danger-occur-statistic-line2',
	redirect: '/object-danger-occur-statistic-line2',
	component: () => import('@/views/layout/Default'),
	children: [
		{
			path: '/',
			name: 'ObjectDangerOccurStatisticLine2Home',
			component: () => import('@/views/biz/ObjectDangerOccurStatisticLine2'),
		},
	],
};
